import React, { useState } from "react";
import useFetch from "../../../../hooks/useAxios";
import AdminCatCard from "./AdminCatCard";

const AdminCategories = () => {
  const [cateList, setcateList] = useState([]);
  const apicateList = useFetch({
    method: "get",
    url: "api/admin/categories",
    noHeader: false,
    trigger: true,
    argFunc: res => setcateList(res.data)
  });
  console.log(cateList);
  return (
    <div className="AdminCategories">
      <h3>دسته بندی های اقامتگاه ها</h3>
      <p className="AdminCategories__p">
        این دسته بندی ها مربوط به دسته بندی اقامتگاه ها در صفحه اصلی می باشد
      </p>

      <div className="AdminCategories__grid">
        {cateList.length > 0 && cateList.map(i =>
          
          <AdminCatCard apicateList={apicateList} info={i} />
          )}
      </div>
    </div>
  );
};

export default AdminCategories;
